import { FC } from "react";
import { pluralize } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const TaskBulkPriorityCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { selectedTaskCount = 0, taskBulkPriorityOptions = [] } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set priority for ${selectedTaskCount} ${pluralize("task", selectedTaskCount)}`}
            options={taskBulkPriorityOptions}
        />
    );
};
